import { Box } from '@gassan-ui'
import styled from 'styled-components'

export const Slide = styled(Box)`
  cursor: pointer;
  scroll-snap-align: start;
  overflow: hidden;
`
